import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// Suppress benign "ResizeObserver loop" errors that CRA overlays as fatal in dev
// (these come from Recharts/Radix during rapid resizes; not a real error)
if (typeof window !== "undefined") {
  window.addEventListener("error", (e) => {
    if (e.message && (e.message.includes("ResizeObserver loop") || e.message.includes("ResizeObserver was made"))) {
      e.stopImmediatePropagation();
    }
  }, true);
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);

// Register PWA service worker so the app is installable and works offline
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/service-worker.js").catch(() => {});
  });
}
